// Stable refusal codes (database `raise ... message = 'CODE'`, Edge Functions, Auth) → translated messages.
// The server decides; this only chooses the words.
const MESSAGES: Record<string, string> = {
  INVALID_CREDENTIALS: 'err.credentials',
  ACCOUNT_DEACTIVATED: 'err.deactivated',
  OFFLINE: 'err.offline',
  DATE_IN_FUTURE: 'err.future',
  WEAK_PASSWORD: 'err.weak',
  EMAIL_TAKEN: 'err.dupemail',
  LAST_OWNER: 'err.lastowner',
  CANNOT_DEACTIVATE_SELF: 'err.self',
  CANNOT_DELETE_SELF: 'err.delself',
  USER_HAS_HISTORY: 'err.userhistory',
  USER_NOT_FOUND: 'err.usernotfound',
  ACCOUNT_NOT_UPDATED: 'err.accountnotupdated',
  SAME_PASSWORD: 'err.sameTemp',
  PASSWORD_MISMATCH: 'err.mismatch',
  INVALID_VALUE: 'err.number',
  REQUIRED_FIELD: 'err.required',
  INVALID_EMAIL: 'err.email',
  NOT_SIGNED_IN: 'refusal.text',
  // P1 catalogue and partners (NAME_TAKEN is worded per record by each sheet).
  NAME_REQUIRED: 'err.required',
  SKU_TAKEN: 'err.sku',
  INVALID_CAPACITY: 'err.capacity',
  PRICE_REQUIRED: 'err.price',
  INVALID_PRICE: 'err.price',
  UNIT_REQUIRED: 'err.unit',
  PRODUCT_LOCKED: 'lock.hint',
  REASON_REQUIRED: 'err.reason',
  SAME_PRICE: 'err.sameprice',
  UNIT_NOT_ALLOWED: 'err.unitnot',
  INVALID_BARCODE: 'err.ean',
  BARCODE_TAKEN: 'err.barcodeused',
  BARCODE_EXISTS: 'err.genexists',
  HAS_HISTORY: 'err.history',
  CATEGORY_CYCLE: 'err.cycle',
  TOO_DEEP: 'err.deep',
  PHONE_TAKEN: 'err.phone',
  GROUP_INACTIVE: 'err.group',
  NOT_FOUND: 'err.notfound',
  // CUS-07 customer visibility.
  NOT_YOURS: 'err.notyours',
  // PRD-12: product photo.
  BAD_IMAGE_PATH: 'photo.notimage',
  TOO_MANY_IMAGES: 'photo.toomany',
  PHOTO_UPLOAD_FAILED: 'photo.uploadfailed',
  ANONYMIZED: 'err.anonymized',
  // P2 stock.
  INVALID_QUANTITY: 'err.qty',
  BOX_FOR_LOOSE: 'err.boxloose',
  ABOVE_BALANCE: 'err.overbalance',
  NO_LINES: 'err.nolines',
  INVALID_COST: 'err.cost',
  OPENING_CLOSED: 'err.opening',
  LOOSE_ONLY: 'err.looseonly',
  NOT_ENOUGH_LOOSE: 'err.notenough',
  // P3 cash and capital (INSUFFICIENT_CASH is worded with its place and balance by the cash sheets).
  INVALID_AMOUNT: 'err.amount',
  INSUFFICIENT_CASH: 'err.cash',
  CONTRIBUTOR_REQUIRED: 'err.contributor',
  RECIPIENT_REQUIRED: 'err.recipient',
  DIRECTION_REQUIRED: 'err.required',
  NOTHING_TO_POST: 'err.bothzero',
  DATE_BEFORE_START: 'err.beforestart',
  // ADR-146 partners (ABOVE_PARTNER_BALANCE and SHARES_NOT_100 are worded with their figures by the sheets).
  ABOVE_PARTNER_BALANCE: 'err.abovepartner',
  CLOSE_PERIOD_FIRST: 'err.closefirst',
  SHARES_NOT_100: 'err.shares100',
  NOTHING_TO_CLOSE: 'err.nothingclose',
  PARTNER_HAS_BALANCE: 'err.partnerbalance',
  PARTNER_NAME_TAKEN: 'err.partnername',
  PARTNER_REQUIRED: 'err.partnerreq',
  PARTNER_NOT_FOUND: 'err.partnerreq',
  PARTNER_INACTIVE: 'err.partnerinactive',
  INVALID_SHARE: 'err.share',
  // ADR-148 backups.
  BACKUP_INVALID: 'err.backupinvalid',
  BACKUP_SCHEMA_MISMATCH: 'err.backupschema',
  BACKUP_INCOMPLETE: 'err.backupincomplete',
  RESTORE_WOULD_LOCK_OWNER: 'err.restorelock',
  CONFIRMATION_REQUIRED: 'err.confirmreq',
  BACKUP_UPLOAD_FAILED: 'err.backupupload',
  BACKUP_NOT_FOUND: 'err.backupnotfound',
  // P4 purchasing (ABOVE_REMAINING, ABOVE_RETURNABLE and INSUFFICIENT_CASH are worded by the purchasing sheets).
  SUPPLIER_REQUIRED: 'err.nosupplier',
  SUPPLIER_INACTIVE: 'err.supinactive',
  PRODUCT_INACTIVE: 'err.prodinactive',
  NOTHING_RECEIVED: 'err.nothing',
  PO_NOT_OPEN: 'err.ponotopen',
  NOT_PARTIAL: 'err.notpartial',
  HAS_RECEIPTS: 'err.cancelafter',
  RECEIPT_REQUIRED: 'err.receiptreq',
  PICKUP_FOR_DELIVERY: 'err.pickupdelivery',
  INVALID_EXPENSE: 'err.amount',
  DATE_IN_PAST: 'err.datepast',
  PAYMENT_REQUIRED: 'err.required',
  DELIVERY_REQUIRED: 'err.required',
  // P5 trucks and rounds (VIN_TAKEN, LIVE_ROUND and ROUND_LIVE are worded with their details by the round sheets).
  CATEGORY_REQUIRED: 'err.category',
  INVALID_VIN: 'err.vin',
  OWNERSHIP_REQUIRED: 'err.ownership',
  OWNER_NAME_REQUIRED: 'err.ownername',
  SELLER_REQUIRED: 'err.seller',
  OWNER_ROUND_NO_WAGE: 'err.ownerwage',
  SAME_SELLER: 'err.sameseller',
  NOT_YOUR_TRUCK: 'err.notyourtruck',
  NOT_YOUR_ROUND: 'err.notyourround',
  ROUND_NOT_OPEN: 'err.roundnotopen',
  NOT_ENDED: 'err.notended',
  ROUND_ENDED: 'err.loadended',
  NO_DIFFERENCE: 'err.nodiff',
  // P6 selling (NOT_ENOUGH_STOCK and OPEN_NOT_CONFIRMED are worded by the sale sheet).
  CUSTOMER_REQUIRED: 'err.nocustomer',
  CUSTOMER_INACTIVE: 'err.custinactive',
  WALK_IN_PAID_IN_FULL: 'err.walkinpaid',
  WALK_IN_PROTECTED: 'err.walkinprotected',
  DISCOUNT_TOO_LARGE: 'err.discount',
  INVALID_DISCOUNT: 'err.invdisc',
  OPEN_NOT_CONFIRMED: 'err.openconfirm',
  SPLIT_INVALID: 'err.split',
  EXTERNAL_TRUCK: 'err.external',
  NOTHING_SELECTED: 'col.nothing',
  INVOICE_NOT_YOURS: 'err.notyoursinv',
  OTHER_CUSTOMER: 'err.othercust',
  NOT_UNPAID: 'err.notunpaid',
  // P10 advanced catalogue.
  ATTR_NONE: 'err.attrnone',
  ATTR_MAX: 'err.attrmax',
  ATTR_VALUE: 'err.attrvalue',
  ATTR_NAME: 'err.attrname',
  ATTR_DUPLICATE: 'err.attrdup',
  VARIANT_EXISTS: 'err.varexist',
  BUNDLE_TOO_FEW: 'err.bun2',
  BUNDLE_NESTED: 'err.bunnested',
  BUNDLE_NO_STOCK: 'err.bunstock',
  LOTS_ALREADY_ON: 'err.lotson',
  LOTS_PERMANENT: 'err.lotsperm',
  LOT_SPLIT_MISMATCH: 'err.lotsplit',
  LOT_REQUIRED: 'err.lotno',
  EXPIRY_REQUIRED: 'err.lotexp',
  EXPIRY_TOO_EARLY: 'err.lotearly',
  LOT_EXPIRY_MISMATCH: 'err.lotmismatch',
  LOT_DUPLICATE: 'err.lotdupe',
  LOT_NOT_EXPIRED: 'err.lotnotyet',
  NO_STOCK_HERE: 'err.nostockhere',
  LOTS_EXPIRED: 'err.lotsexpired',
  HAS_OPEN_ITEMS: 'err.openitems',
  // P9 pre-orders.
  PRE_ORDER_NOT_OPEN: 'err.prenotopen',
  PRE_ORDER_MISMATCH: 'err.premismatch',
  SELLER_NOT_ALLOWED: 'err.sellerself',
  NOT_YOUR_PRE_ORDER: 'err.notyourpre',
  INVALID_DATE: 'err.wantedpast',
  // P8 returns and corrections.
  RETURN_WINDOW_PASSED: 'err.window',
  ABOVE_RETURNABLE: 'err.aboveret',
  NOT_PAID: 'err.notpaid',
  INVOICE_NOT_HELD: 'err.notheld',
  ALREADY_REVERSED: 'err.reversed',
  INSUFFICIENT_FUNDS: 'err.funds',
  INSUFFICIENT_ROUND_CASH: 'err.roundcash',
  INVALID_MINIMUM: 'err.minimum',
  INVALID_PCT: 'err.pct',
  END_BEFORE_START: 'err.dates',
  NOT_ENOUGH_STOCK: 'err.stockshort',
};

/** The i18n key for a refusal code; unknown codes get the generic message. */
export function messageKey(code: string): string {
  return MESSAGES[code] ?? 'err.generic';
}
